export default class DesignBuilderContainer {
  constructor(container) {
    this.containerId = container.containerId;
    this.name = container.name;
    this.containerType = 'Room';
    this.items = container.items;
    this.charLabel = container.charLabel;
  }
}
